export interface IBaseToast {
  duration?: number;
  left?: number;
  top?: number;
  right?: number;
  bottom?: number;
  className?: string;
  static?: boolean;
}

export interface IToast extends IBaseToast {
  children(id: string): React.ReactNode;
}

export enum ToastType {
  SUCCESS = 'Success',
  DANGER = 'Danger'
}

export interface IListPageToast extends IBaseToast {
  message?: string;
  colorType?: 'Success' | 'Danger';
  icon?: string;
  toastClassName?: string;
  iconClassName?: string;
  textClassName?: string;
  closeButtonClassName?: string;
}

export interface IBaseToastProps {
  id: string;
}

export interface IListPageToastProps extends IBaseToastProps {
  toast: IListPageToast;
}

export interface IToastProps extends IBaseToastProps {
  toast: IBaseToast;
  children?: React.ReactNode;
}

export type ToastColors = {
  dangerBg: string;
  dangerFont: string;
  successBg: string;
  successFont: string;
};
